export default "<app-verticals-full></app-verticals-full>"